import { DeleteResponse, SupportListResponse, SupportResponse } from '../dto/ResDtoRepository';
import { CreateSupportReq, MetadataForQuery, DeleteSupportReq, UpdateSupportReq } from '../dto/ReqDtoRepository';
import { SupportSortData } from '../dto/EntityRepository';
import { sendApiRequest, sendDeleteApiRequest } from './apiConfig';

//Admin
export const getSupport = async (supportId: string): Promise<SupportResponse> => {
  return sendApiRequest<SupportResponse>('get', `/api/v1/support?supportId=${supportId}`);
};

//Admin
export const getSupportList = async (aui: string, metaData: MetadataForQuery): Promise<SupportListResponse> => {
  const sortData = metaData.sortData as SupportSortData;
  return sendApiRequest<SupportListResponse>('get', `/api/v1/support/list?page=${metaData.page}&size=${metaData.size}&sortBy=${sortData.sort}&direction=${sortData.direction}`);
};

export const createSupport = async (aui: string, data: CreateSupportReq): Promise<SupportResponse> => {
  return sendApiRequest('post', `/api/v1/support?aui=${aui}`, data);
};

export const updateSupport = async (aui: string, data: UpdateSupportReq): Promise<SupportResponse> => {
  return sendApiRequest('put', `/api/v1/support?aui=${aui}`, data);
};

export const deleteSupport = async (aui: string, data: DeleteSupportReq) => {
  return sendDeleteApiRequest<DeleteResponse>(`/api/v1/support?aui=${aui}&supportId=${data.supportId}`);
};